import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

export default function Keyholding() {
  return (
    <div className="min-h-screen bg-[#111111] text-white">
      <Helmet>
        <title>Keyholding | SeguraTech</title>
        <meta
          name="description"
          content="Professional keyholding with emergency access for the verified account holder. Secure, recorded, and designed to help you regain access if you're locked out."
        />
      </Helmet>

      {/* Top section – service overview */}
      <section className="max-w-6xl mx-auto px-4 pt-20 pb-16">
        <div className="max-w-3xl">
          <h1 className="text-4xl md:text-5xl font-extrabold text-[#C6A564] mb-6">
            Keyholding
          </h1>

          <p className="text-lg text-white/80 mb-6">
            SeguraTech Keyholding is a professional service designed to help you regain
            access to your property or vehicle if you are locked out. Your keys are held
            securely and are used only to provide access to you, following identity
            verification.
          </p>

          <ul className="list-disc list-inside text-white/80 space-y-2">
            <li>Secure storage of your keys</li>
            <li>Emergency access for the verified account holder only</li>
            <li>Identity verification at every attendance</li>
            <li>Recorded attendance for safety and accountability</li>
            <li>Starting from only £60 per year</li>
          </ul>

          <p className="text-white/70 mt-6">
            This service is not intended for routine access, shared access, or property
            management.
          </p>
        </div>
      </section>

      {/* Action boxes */}
      <section className="max-w-6xl mx-auto px-4 pb-24">
        <div className="grid md:grid-cols-3 gap-8">
          {/* FAQ Box */}
          <Link
            to="/secure-keyholding/faq"
            className="border border-[#C6A564] rounded-2xl p-8 bg-[#1a1a1a] hover:bg-[#222222] transition block"
          >
            <h2 className="text-2xl font-semibold text-[#C6A564] mb-3">
              FAQs
            </h2>
            <p className="text-white/80">
              Clear answers about how keyholding works, identity verification,
              call-outs, pricing, and what to expect.
            </p>
          </Link>

          {/* Terms Box */}
          <Link
            to="/secure-keyholding/terms"
            className="border border-[#C6A564] rounded-2xl p-8 bg-[#1a1a1a] hover:bg-[#222222] transition block"
          >
            <h2 className="text-2xl font-semibold text-[#C6A564] mb-3">
              Terms & Conditions
            </h2>
            <p className="text-white/80">
              The contractual terms governing the Secure Keyholding and
              Emergency Access service.
            </p>
          </Link>

          {/* Policies Box */}
          <Link
            to="/secure-keyholding/policies"
            className="border border-[#C6A564] rounded-2xl p-8 bg-[#1a1a1a] hover:bg-[#222222] transition block"
          >
            <h2 className="text-2xl font-semibold text-[#C6A564] mb-3">
              Policies
            </h2>
            <p className="text-white/80">
              Operational policies covering identity verification, recording,
              access rules, and safety procedures.
            </p>
          </Link>
        </div>
      </section>
    </div>
  );
}
